// Minimal RFC4180-compliant CSV utilities.
// - stringify(rows) — rows is a 2-D array of strings/numbers/bools/null
// - parse(text)     — returns a 2-D array of strings (all values as strings)

const escapeCell = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v);
  if (s.includes(",") || s.includes("\n") || s.includes("\r") || s.includes('"')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

export function stringify(rows) {
  return rows.map((r) => r.map(escapeCell).join(",")).join("\r\n");
}

// Parse a CSV string into 2-D array of strings. Handles quoted fields,
// escaped quotes ("") inside them, and CRLF/LF line endings.
export function parse(text) {
  const rows = [];
  let row = [];
  let cur = "";
  let i = 0;
  let inQuotes = false;
  const src = text.replace(/^\ufeff/, ""); // strip BOM
  while (i < src.length) {
    const ch = src[i];
    if (inQuotes) {
      if (ch === '"') {
        if (src[i + 1] === '"') { cur += '"'; i += 2; continue; }
        inQuotes = false; i++; continue;
      }
      cur += ch; i++; continue;
    }
    if (ch === '"') { inQuotes = true; i++; continue; }
    if (ch === ",") { row.push(cur); cur = ""; i++; continue; }
    if (ch === "\r") { i++; continue; } // ignore \r; handled by \n
    if (ch === "\n") { row.push(cur); rows.push(row); row = []; cur = ""; i++; continue; }
    cur += ch; i++;
  }
  // flush the last cell/row (only if non-empty final line)
  if (cur.length > 0 || row.length > 0) {
    row.push(cur);
    rows.push(row);
  }
  // Trim purely empty trailing rows
  while (rows.length > 0 && rows[rows.length - 1].every((c) => c === "")) rows.pop();
  return rows;
}

export function downloadCSV(filename, csvText) {
  const blob = new Blob(["\ufeff" + csvText], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
